<template>
  <div class="search-flex">
    <div>
      <el-date-picker style="width: 250px; margin-right: 20px" v-model="searchParams.createTime" type="daterange"
        size="small" range-separator="-" start-placeholder="添加时间开始" end-placeholder="添加时间结束" format="yyyy-MM-dd"
        clearable>
      </el-date-picker>
      <el-input class="search_input" clearable placeholder="卡片名称" size="small" v-model="searchParams.name"></el-input>
      <!-- 卡片类型 (1：焦点卡片；2：专题卡片；3：导航卡片 4: 榜单卡片 5：追剧投屏卡片；6：内容卡片；7：内容横滑卡片；8：直播卡片 9：导航横滑卡片 10: 焦点组卡片） -->
      <el-select class="search_input" clearable placeholder="卡片类型" size="small" v-model="searchParams.type">
        <el-option label="焦点卡片" :value="1"> </el-option>
        <el-option label="专题卡片" :value="2"> </el-option>
        <el-option label="导航卡片" :value="3"> </el-option>
        <el-option label="榜单卡片" :value="4"> </el-option>
        <el-option label="追剧投屏卡片" :value="5"> </el-option>
        <el-option label="内容卡片" :value="6"> </el-option>
        <el-option label="内容横滑卡片" :value="7"> </el-option>
        <el-option label="直播卡片" :value="8"> </el-option>
        <el-option label="导航横滑卡片" :value="9"> </el-option>
        <el-option label="焦点组卡片" :value="10"> </el-option>
      </el-select>
      <!-- 状态（1：生效；0：失效 2；待生效） -->
      <el-select class="search_input" clearable placeholder="状态" size="small" v-model="searchParams.status">
        <el-option label="待生效" :value="2"> </el-option>
        <el-option label="生效" :value="1"> </el-option>
        <el-option label="失效" :value="0"> </el-option>
      </el-select>
    </div>
    <div class="search-btn">
      <!-- 搜索按钮 -->
      <el-button v-auth="'APP_CARD_SEARCH'" type="primary" size="small" @click="search(1)">搜索</el-button>
      <!-- 新增按钮 -->
      <el-button v-auth="'APP_CARD_ADD'" size="small" @click="add">新增</el-button>
    </div>
    <EditDialog ref="editDialog" @reload="reload"></EditDialog>
  </div>
</template>

<script>
import { getAppCardList } from "@/api/apps/appCard";
import Message from "@/components/Message";
import moment from "moment";
import EditDialog from "./edit.vue";
export default {
  inject: ["searchParams", "list"],
  name: "WebSaaSSearch",
  components: {
    EditDialog,
  },

  data() {
    return {};
  },

  methods: {
    /** 刷新列表 */
    reload() {
      console.log("search-reload");
      this.search();
    },
    /** 搜索 */
    async search(opt) {
      const params = { ...this.searchParams };
      this.searchParams.current = 1;
      try {
        params.createDateBegin = params.createTime
          ? moment(params.createTime[0]).format("YYYY-MM-DD")
          : "";
        params.createDateEnd = params.createTime
          ? moment(params.createTime[1]).format("YYYY-MM-DD")
          : "";
        delete params.createTime;
      } catch (error) {
        console.log("时间格式化错误");
        console.log(error);
      }
      console.log("搜索的参数", params);
      const { data } = await getAppCardList(params);
      console.log("搜索的响应", data);
      this.list.value = data.data.records;
      this.searchParams.total = data.data.total;
      opt && Message.success("搜索成功");
    },
    /** 新增的事件 */
    add() {
      this.$refs.editDialog.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;

  align-items: flex-start;
}

.search-btn {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.search_input {
  width: 160px !important;
  margin: 10px 20px 0 0;
}
</style>
